// extracted by mini-css-extract-plugin
export var content = "backgroundHeroImage-module--content--6becb";
export var textContent = "backgroundHeroImage-module--textContent--36042";
export var wrapper = "backgroundHeroImage-module--wrapper--bf509";